/** Diagnostic identity only. Connection URLs may contain credentials in
 * userinfo, paths, query parameters or fragments; none belong in the DOM. */
export function feedEndpointLabel(raw: string | null | undefined): string {
  if (!raw) return 'Upstream unavailable';
  try {
    const url = new URL(raw);
    if (!['http:', 'https:', 'ws:', 'wss:'].includes(url.protocol) || !url.hostname) return 'Configured upstream';
    return `${url.protocol}//${url.host}`;
  } catch {
    return 'Configured upstream';
  }
}
